var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4C0 6.4471 6.4471 0 14.4 0H21.6C29.5529 0 36 6.4471 36 14.4V21.6C36 29.5529 29.5529 36 21.6 36H14.4C6.4471 36 0 29.5529 0 21.6V14.4Z",
    fill: "#F0F1EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 19.875C15.8723 19.875 16.3492 19.6775 16.7008 19.3258C17.0525 18.9742 17.25 18.4973 17.25 18C17.25 16.965 16.875 16.5 16.5 15.75C15.696 14.1428 16.332 12.7095 18 11.25C18.375 13.125 19.5 14.925 21 16.125C22.5 17.325 23.25 18.75 23.25 20.25C23.25 20.9394 23.1142 21.6221 22.8504 22.2591C22.5865 22.896 22.1998 23.4748 21.7123 23.9623C21.2248 24.4498 20.646 24.8365 20.0091 25.1004C19.3721 25.3642 18.6894 25.5 18 25.5C17.3106 25.5 16.6279 25.3642 15.9909 25.1004C15.354 24.8365 14.7752 24.4498 14.2877 23.9623C13.8002 23.4748 13.4135 22.896 13.1496 22.2591C12.8858 21.6221 12.75 20.9394 12.75 20.25C12.75 19.3853 13.0748 18.5295 13.5 18C13.5 18.4973 13.6975 18.9742 14.0492 19.3258C14.4008 19.6775 14.8777 19.875 15.375 19.875Z",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalory);
export default __webpack_public_path__ + "static/media/calory.8affe229b3c687d7137e3a5ff6c917f9.svg";
export { ForwardRef as ReactComponent };